import Landmark from '@core/scripts/components/landmark-adapter';

const sendWishListItemRemoveLandMark = ({
                                            itemOptionName,
                                            articleNumber,
                                            promotion,
                                            articlePrice,
                                            shopId,
                                            digistyleId,
                                            masterStyleId,
                                            itemId,
                                            itemOptionId,
                                            origin,
                                            fktId=""
                                        }) => {

    if(
        typeof articlePrice === 'string' &&
        articlePrice.includes(",")
    ) {
        articlePrice = articlePrice.substring(2).replace(',', '.');
    }
    const landMarkData = {
        landmark: "action",
        remwlArtGr: itemOptionName || "",
        remwlArtNr: articleNumber + (promotion ? promotion : ''),
        remwlArtPreis: articlePrice || "",
        remwlShop: shopId,
        remwlFktId: fktId,
        remwlMenge: 1,
        remwlDigistyleId: digistyleId,
        remwlItemId: itemId,
        remwlItemoptionId: itemOptionId,
        remwlOrigin: origin,
        remwlStyle: masterStyleId
    };
    Landmark.sendLandmark(landMarkData);
};

const sendWishListItemAddLandMark = ({
                                         itemOptionName,
                                         articleNumber,
                                         promotion,
                                         articlePrice,
                                         shopId,
                                         digistyleId,
                                         masterStyleId,
                                         itemId,
                                         itemOptionId,
                                         origin,
                                         fktId="",
                                         eventId
                                     }) => {
    // Reco sliders give a whole object
    if (
        typeof articlePrice === 'object' &&
        !Array.isArray(articlePrice) &&
        articlePrice !== null
    ) {
        articlePrice = articlePrice.current.value.substring(2).replace(',', '.');
    }
    const landMarkData = {
        landmark: "action",
        wishArtGr: itemOptionName || "",
        wishArtNr: articleNumber + (promotion ? promotion : ''),
        wishArtPreis: articlePrice || "",
        wishShop: shopId,
        wishFktId: fktId,
        wishMenge: 1,
        wishDigistyleId: digistyleId,
        wishItemId: itemId,
        wishItemoptionId: itemOptionId,
        wishOrigin: origin,
        wishStyle: masterStyleId,
        eventId: eventId
    };
    Landmark.sendLandmark(landMarkData);
};

export default {
    sendWishListItemRemoveLandMark,
    sendWishListItemAddLandMark
};